import * as React from 'react';
import { SVGProps } from 'react';

const IconUnlockSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4.5a1.5 1.5 0 1 1 3 0V6H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7V4.5a2.5 2.5 0 0 0-5 0V5h1v-.5Zm7.5 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
  </svg>
);
export default IconUnlockSizeS;
